import { render, staticRenderFns } from "./ExtractResults.vue?vue&type=template&id=16a2c26f"
import script from "./ExtractResults.vue?vue&type=script&lang=js"
export * from "./ExtractResults.vue?vue&type=script&lang=js"
import style0 from "./ExtractResults.vue?vue&type=style&index=0&id=16a2c26f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a2c26f')) {
      api.createRecord('16a2c26f', component.options)
    } else {
      api.reload('16a2c26f', component.options)
    }
    module.hot.accept("./ExtractResults.vue?vue&type=template&id=16a2c26f", function () {
      api.rerender('16a2c26f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ExtractResults.vue"
export default component.exports